import React from 'react';
import { WebsiteName } from '../../App';
import HeroPage from '../Hero/HeroPage';
import BlogPost from '../Posts/BlogPost';
import blogData from '../../PostData/blogData';

const Blog = () => {
    document.title = "Blog | " + WebsiteName;

    return (
        <>
            {<HeroPage title="Checkout My Latest Blog"></HeroPage>}

            <main>
                <section className="blogPage" id="blogPage">
                    <div className="container fullwidth">
                        <div className="blogWrap">
                            {blogData.map(blog => <BlogPost blogData={blog} key={blog.id}></BlogPost>)}
                        </div> {/* Blog Wrap */}
                    </div> {/* Container */}
                </section> {/* Blog Page */}
            </main>
        </>
    );
};

export default Blog;